import {scoreBadge} from "../../utilities/general"

export const OrientationReadinessColumn = ({percentOSRScore}) => {
    const osrMax = scoreBadge(percentOSRScore, 100)

    return (
        <div className="col">
            <div className="d-flex align-items-center w-100 flex-column mb-lg-0 p-4">
                <div className="d-flex justify-content-between w-100 mb-3">
                    <span className="fw-semibold fs-6">
                        Current Readiness Score: {osrMax.score ? `${osrMax.score}%` : ""}
                    </span>
                    <div className={`badge px-4 py-3 ${osrMax.background} ${osrMax.textColor}`}>{osrMax.badge}</div>
                </div>
                <div className="h-15px mx-3 rounded w-100 bg-secondary">
                    <div className={`rounded h-15px ${osrMax.color}`} style={{width: `${osrMax.width}%`}}></div>
                </div>
            </div>
        </div>
    )
}
